module.exports = __webpack_public_path__ + "img/csr_110923_D.9cf74448.jpg";